import React, { useState } from 'react';
import { BanjoString } from '@stashinvest/react-banjo';
import {
	LegalEllipsizer,
	LegalString,
	PartialSheet,
} from '@stashinvest/react-components';

const LinkBankMicrosDisclosure = () => {
	const [showMore, setShowMore] = useState(false);
	const toggleMore = (e) => {
		if (!showMore) {
			e.preventDefault();
		}
		setShowMore((prevState) => !prevState);
	};
	return (
		<>
			<LegalEllipsizer expandText="More" onExpand={toggleMore}>
				<BanjoString stringId="information/disclose/linkedBankApproval" />
			</LegalEllipsizer>

			{showMore && (
				<PartialSheet onClose={toggleMore}>
					<LegalString>
						<BanjoString stringId="information/disclose/linkedBankApproval" />
					</LegalString>
				</PartialSheet>
			)}
		</>
	);
};

export default LinkBankMicrosDisclosure;
